import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1977d84c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "d-flex justify-content-center pb-10" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "text-start mb-6" }
const _hoisted_5 = {
  class: "fs-4 text-gray-600 fw-semibold",
  style: {"width":"880px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Declaramos para os devidos fins que a certificação número ")
const _hoisted_7 = { class: "fw-bold text-gray-700" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" é autêntico e foi expedido pela CROWSEC para ")
const _hoisted_11 = { class: "fw-bold text-gray-700" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" no dia ")
const _hoisted_13 = { class: "fw-bold text-gray-700" }
const _hoisted_14 = { class: "certificate-container" }
const _hoisted_15 = { style: {"height":"1032px","width":"100%","display":"-webkit-box"} }
const _hoisted_16 = {
  class: "text-white",
  style: {"text-align":"left","margin-top":"160px","margin-left":"60px","width":"50%","height":"70%"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"20px","margin-bottom":"5px","font-family":"'proxima-nova, sans-serif'","font-weight":"300","letter-spacing":"1px","font-style":"normal"} }, " Certificamos que ", -1))
const _hoisted_18 = { style: {"margin-top":"15px","font-family":"proxima-nova, sans-serif","font-weight":"800","font-size":"30px","text-transform":"uppercase"} }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div style=\"margin-top:15px;font-size:20px;margin-bottom:5px;font-family:&#39;proxima-nova, sans-serif&#39;;font-weight:300;letter-spacing:1px;font-style:normal;\" data-v-1977d84c> Concluiu com êxito o Crowsec Web Hacking Initial e executou todos os passos necessários de um Pentest. </div><div style=\"display:flex;align-items:center;margin-top:95px;\" data-v-1977d84c><div class=\"text-white\" style=\"margin-left:-25px;\" data-v-1977d84c><div style=\"font-family:proxima-nova, sans-serif;font-weight:500;letter-spacing:1px;font-size:16px;\" data-v-1977d84c> Carlos Eduardo Vieira </div><div style=\"margin-top:0;font-weight:100;font-size:16px;\" data-v-1977d84c> Avaliador Técnico </div></div><div class=\"text-white\" style=\"margin-left:35px;\" data-v-1977d84c><div style=\"font-family:proxima-nova, sans-serif;font-weight:500;letter-spacing:1px;font-size:16px;\" data-v-1977d84c> Luciane Cichon Goes </div><div style=\"margin-top:0;font-weight:100;font-size:16px;\" data-v-1977d84c> CEO </div></div></div>", 2)
const _hoisted_21 = {
  class: "text-white",
  style: {"margin-top":"30px","margin-left":"-50px","font-size":"10px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"100"} }, " Valide o certificado em https://app.hackingclub.com/certificate/validate ", -1))
const _hoisted_23 = { style: {"font-weight":"100"} }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Código de segurança: ")
const _hoisted_25 = ["href"]
const _hoisted_26 = { style: {"font-weight":"100"} }

import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  props: {
  certification: {}
},
  setup(__props) {

const props = __props


const formatDate = (date: string) =>{
  return moment(date).format('DD/MM/YY');
}

const slugToName = (slug: string) =>{
  return slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.certification?.validation_id), 1),
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(__props.certification?.user_name), 1),
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(__props.certification?.issue_date)) + ".", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(__props.certification.user_name), 1),
              _hoisted_19,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("a", {
                    href: `https://app.hackingclub.com/certificate/validate?id=${__props.certification.validation_id}`,
                    target: "_blank",
                    style: {"text-decoration":"none","color":"white"}
                  }, _toDisplayString(__props.certification.validation_id), 9, _hoisted_25)
                ]),
                _createElementVNode("div", _hoisted_26, " Emissão realizada em " + _toDisplayString(formatDate(__props.certification?.issue_date)), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})